import React, { useEffect } from 'react';
import { Layout, message } from 'antd';
import LoginForm from './Components/LoginForm';

const { Content } = Layout;

/**
 * Login Page
 *
 * Displays the login screen with a login form for username, password, and captcha verification.
 */
const LoginPage: React.FC = () => {
  // 檢查是否因為自動登出而返回登入頁面
  useEffect(() => {
    const autoLogout = sessionStorage.getItem('auto_logout');
    if (autoLogout === 'true') {
      // 顯示自動登出的提示信息
      message.warning('因為長時間無操作，您已被自動登出。請重新登入。');
      // 清除記錄，以避免重複顯示
      sessionStorage.removeItem('auto_logout');
    }
  }, []);

  return (
    <Content className="login-page-container">
      <LoginForm />
    </Content>
  );
};

export default LoginPage;
